// Studby — renders AI markdown answers (with LaTeX math) using themed styling.
import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

// GPT-4o emits LaTeX with \( ... \) and \[ ... \] delimiters, but remark-math
// expects $ ... $ and $$ ... $$. Convert them before rendering.
function normalizeMath(text) {
  if (typeof text !== "string") return text;
  return text
    .replace(/\\\[([\s\S]*?)\\\]/g, (_, m) => `\n$$${m}$$\n`)
    .replace(/\\\(([\s\S]*?)\\\)/g, (_, m) => `$${m}$`);
}

export function Markdown({ children, testId }) {
  return (
    <div className="md-content text-[15px]" data-testid={testId}>
      <ReactMarkdown remarkPlugins={[remarkMath]} rehypePlugins={[rehypeKatex]}>
        {normalizeMath(children)}
      </ReactMarkdown>
    </div>
  );
}
